import React from 'react'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    borderRadius: 4,
    backgroundColor: '#ffffff',
    outline: 'none',
    width: '267px',
    height: '168px',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  title: {
    width: '227px',
    height: '72px',
    margin: '0 auto',
    marginTop: '20px',
    marginBottom: '20px',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    color: '#000000',
    textAlign: 'center',
  },
  banBtnBox: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 20px',
  },
  btnCansel: {
    width: '93px',
    height: '36px',
    border: 'none',
    color: '#2196F3',
    backgroundColor: '#E3F2FD',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '5px',
    boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24);',
  },
  btnDelete: {
    width: '93px',
    height: '36px',
    border: 'none',
    color: '#ffffff',
    backgroundColor: '#2196F3',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '5px',
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
    '&:hover': {
      backgroundColor: '#ffffff',
      color: '#2196F3',
    },
  },
  googleLogo: {
    width: '18px',
    height: '18px',
    marginRight: '24px',
  },
  closeIcon: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    '&:hover': {
      cursor: 'pointer',
      opacity: '0.5',
    },
  },
}))

const DeleteModal = ({ open, setOpen, setDeleteUser, onDelete, name }) => {
  const classes = useStyles()
  const handleClose = () => {
    setOpen(false)
    setDeleteUser({})
  }

  return (
    <div>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div className={classes.title}>
              Are you sure that you want to delete {name}?<br />
              Such action can’t be undone.
            </div>
            <div className={classes.banBtnBox}>
              <Button
                onClick={() => handleClose()}
                className={classes.btnCansel}
              >
                Cancel
              </Button>
              <Button
                onClick={onDelete}
                className={classes.btnDelete}
              >
                Delete
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  )
}

export default DeleteModal
